import React, { Component } from 'react';
import ContentHeader from "./content-header";
import ContentNavigationContainer from "../appointment-table/nav";
import AppointmentTableContainer from "../appointment-table";

export default class ContentContainer extends Component {
    render(){
        return(
            <div className="content-container">
                <div className="grid-column">
                    <ContentHeader/>
                    <ContentNavigationContainer/>
                    <AppointmentTableContainer/>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// frontend/src/modules/content/ContentContainer.jsx